export enum ValidationType {
  Numeric="Numeric",
  RegularExpression="RegularExpression",
  // Date="Date"
}
